// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___hjxO","content":"styles_content__2W6By"};